import React from "react";
import AuthBNB from "./wod/AuthBNB";
import { HashLoader } from "react-spinners";

import "./menu.scss";
import { shortAddress } from "../utils/shortAddress";
const catNumbers = Array(10)
  .fill(0)
  .map((_, i) => i + 1);
// const lastUnlockedLevel = 10;

export default class Menu extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.loadLeaderboardData();
    // this.props.loadScores();
  }

  handleStart = (e) => {
    e.preventDefault();

    let gameStartConfig = {
      username: this.props.username,
      selectedCat: this.props.selectedCat,
      selectedLevel: this.props.selectedLevel,
      areGameSoundsOn: this.props.areGameSoundsOn,
    };

    window.gameStartConfig = gameStartConfig;
    this.props.startGame();
  };

  render() {
    const lastUnlockedLevel = this.props.lastUnlockedLevel;

    const formatTimeBySecond = (bestTime) => {
      let check = Number(bestTime);

      if (check !== 0) {
        let date = new Date(null);

        date.setSeconds(bestTime);

        return date.toISOString().substr(11, 8);
      } else {
        return "DNF";
      }
    };

    const formatTimeByLevelAndSecond = (bestTime, level) => {
      if (level === 10) {
        let check = Number(bestTime);

        if (check !== 0) {
          let date = new Date(null);

          date.setSeconds(bestTime);

          return date.toISOString().substr(11, 8);
        }
      } else {
        return "DNF";
      }
    };

    const leaderboard = this.props.leaderboard.sort(
      (a, b) => b.score - a.score || a.timestamp - b.timestamp
    );

    const override2 = {
      display: "block",
      margin: "auto",
      borderColor: "#554fd8",
      position: "relative",
    };

    const caws2dRewards = [
      100, 60, 40, 30, 20, 20, 20, 20, 20, 20, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
    ];

    return (
      <div className="menu container pt-4">
        {/* <h2 className="text-center">Platformer Game</h2> */}
        <div className="text-center">
          <img
            src="/assets/images/game-title.png"
            style={{ width: "80%", maxWidth: "512px", objectFit: "contain" }}
          />
        </div>
        <div
          // onSubmit={this.handleStart}
          className="d-flex flex-column gap-4 mt-3 justify-content-center"
          // style={{ maxWidth: "800px", margin: "auto" }}
        >
          {this.props.loadingPlayer === true ? (
            <>
              <HashLoader
                color={"#554fd8"}
                loading={this.props.loadingPlayer}
                cssOverride={override2}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </>
          ) : this.props.email &&
            this.props.loadingPlayer === false &&
            this.props.userId &&
            this.props.wodUsername &&
            this.props.address ? (
            <div className="user-cardImg">
              <div className="d-flex p-3 bordereddiv  align-items-center gap-2 w-100 justify-content-between">
                <div className="d-flex flex-column gap-1">
                  <span className="username-txt">{this.props.wodUsername}</span>
                  <span className="email-txt">{this.props.email}</span>
                  <span className="wallet-txt">
                    {shortAddress(this.props.address)}
                  </span>
                </div>
                <button
                  onClick={this.props.LogoutClick}
                  className="withdrawbtn border-0 py-1 px-3"
                >
                  Log out
                </button>
              </div>
              {this.props.isConnected === false && !this.props.wallet && (
                <div className="d-flex flex-column justify-content-between flex-xxl-row flex-lg-row px-3 py-2  align-items-center gap-2">
                  <p className="walletassoc-txt m-0">
                    *Connect your wallet to view more info.
                  </p>
                  <button
                    className="d-flex gap-2 px-3 py-1 align-items-center pill-btn"
                    onClick={this.props.handleConnectWallet}
                  >
                    Connect wallet
                  </button>
                </div>
              )}
              {this.props.isConnected === true &&
                this.props.wallet &&
                this.props.address &&
                this.props.wallet.toLowerCase() ===
                  this.props.address.toLowerCase() && (
                  <div className="d-flex flex-column justify-content-between flex-xxl-row flex-lg-row px-3 py-2  align-items-center gap-2">
                    <p className="walletassoc-txt m-0">
                      You must hold CAWS NFT to play.
                    </p>
                    <div className="form-group m-0">
                      <div className="custom-control custom-switch">
                        <input
                          checked={this.props.areGameSoundsOn}
                          onChange={(e) =>
                            this.props.onGameSoundsOn(e.target.checked)
                          }
                          type="checkbox"
                          className="custom-control-input"
                          id="sounds-on-checkbox"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="sounds-on-checkbox"
                        >
                          Game Sounds{" "}
                          <i
                            style={{ width: "20px", height: "20px" }}
                            className={`fa-solid fa-volume-${
                              this.props.areGameSoundsOn ? "high" : "xmark"
                            }`}
                          ></i>{" "}
                        </label>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          ) : (
            <AuthBNB
              onSuccessLogin={this.props.onSuccessLogin}
              isConnected={this.props.isConnected}
              coinbase={this.props.wallet}
              handleConnect={this.props.handleConnect}
              onWalletLinkComplete={this.props.onWalletLinkComplete}
              isSuccess={this.props.isSuccess}
            />
          )}
          {/* {this.props.email && this.props.loadingPlayer === false && (
            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-4 mt-4">
                  <label>Connect Wallet to Play</label>
                  <button
                    onClick={this.props.handleConnectWallet}
                    style={{
                      boxShadow: "none",
                      border: "none",
                      background: "#ec553b",
                      color: "white",
                    }}
                    className="btn btn-block"
                    type="button"
                  >
                    {this.props.signature === null
                      ? "Connect Wallet"
                      : "Wallet Connected!"}
                  </button>
                  <small className="form-text text-light">
                    You must hold CAWS NFT to play.
                  </small>
                </div>
              </div>
              
            </div>
          )} */}
          {this.props.email && this.props.loadingPlayer === false && (
            <div className="row">
              <div className="d-flex flex-column flex-lg-row gap-2">
                <div className="w-100">
                  <div className="form-group">
                    <label>Select Level</label>
                    <div className="item-grid-wrapper">
                      {catNumbers.map((number) => {
                        return (
                          <div
                            key={number}
                            className="mb-2 position-relative grid-item"
                          >
                            {/* <img onClick={() => this.props.setAppState({selectedCat: number})} className={`rounded border border-${this.props.appState.selectedCat == number?'danger':'light'}`} src={`/assets/images/cats/${number}.png`} style={{width: '100%', height: '100%', objectFit: 'fill'}} /> */}
                            <span
                              onClick={() => {
                                if (lastUnlockedLevel < number) return;
                                this.props.onSelectedLevel(number);
                              }}
                              className={`level-number-span ${
                                lastUnlockedLevel < number ? "item-locked" : ""
                              } text-center rounded border border-${
                                this.props.selectedLevel == number
                                  ? "danger"
                                  : "light"
                              }`}
                            >
                              {" "}
                              {number}{" "}
                            </span>
                            <i
                              style={{ bottom: "8px", right: "12px" }}
                              className={`position-absolute fa-solid fa-lock${
                                lastUnlockedLevel < number ? "" : "-open"
                              }`}
                            ></i>
                          </div>
                        );
                      })}
                    </div>
                    {/* <div>
                                {catNumbers.map((number) => {
                                    return (
                                        <div key={number} className="custom-control custom-radio">
                                            <input value={number} onChange={() => this.props.setAppState({selectedLevel: number})} checked={this.props.appState.selectedLevel == number} disabled={lastUnlockedLevel < number} name="selected-level" type="radio" className="custom-control-input" id={`level-${number}-radio`} />
                                            <label className="custom-control-label" htmlFor={`level-${number}-radio`}><i className={`fa-solid fa-lock${lastUnlockedLevel < number ? '' : '-open'}`}></i> Level {number}</label>
                                        </div>
                                    )
                                })}
                            </div> */}
                  </div>
                </div>
                <div className="w-100">
                  <div className="form-group">
                    <label>Select Cat</label>
                    <div className="item-grid-wrapper">
                      {catNumbers.map((number) => {
                        return (
                          <div key={number} className="mb-2 grid-item">
                            <img
                              onClick={() => {
                                if (lastUnlockedLevel < number) {
                                  return;
                                }
                                this.props.onSelectCat(number);
                              }}
                              className={`rounded ${
                                lastUnlockedLevel < number ? "item-locked" : ""
                              } border border-${
                                this.props.selectedCat == number
                                  ? "danger"
                                  : "light"
                              }`}
                              src={`/assets/images/cats/${number}.png`}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "fill",
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="form-group text-center"
                onClick={this.handleStart}
              >
                <div style={{ width: "128px", margin: "auto" }}>
                  <button
                    style={{
                      boxShadow: "none",
                      border: "none",
                      background: "#ec553b",
                      color: "white",
                    }}
                    className="btn btn-block btn-lg"
                    type="submit"
                  >
                    <i
                      style={{ fontSize: "3rem" }}
                      className="fa-solid fa-play"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {this.props.email && this.props.loadingPlayer === false && (
          <div className="leaderboard-wrapper mt-5 mb-5 d-flex flex-column gap-3">
            {this.props.signature !== null &&
              this.props.leaderboardScore !== null && (
                <div>
                  <h2 style={{ color: "#ec553b" }}>
                    MY BEST SCORES (TOTAL:{" "}
                    {this.props.leaderboardScore
                      ? this.props.leaderboardScore.score
                      : ""}
                    )
                  </h2>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>LEVEL</th>
                          <th className="text-right">SCORE</th>
                          <th className="text-right">TIME</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.bestScores.map((item, i) => (
                          <tr key={i}>
                            <td>Level {item.level} </td>
                            <td className="text-right"> {item.score} </td>
                            <td className="text-right">
                              {" "}
                              {formatTimeBySecond(item.timestamp)}{" "}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

            <h2 style={{ color: "#ec553b" }}>LEADERBOARD</h2>
            <div className="table-responsive custom-table">
              <table className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    {/* <th>ADDRESS</th> */}
                    <th>USERNAME</th>
                    <th className="text-right">SCORE</th>
                    <th className="text-right">LEVEL</th>
                    <th className="text-right">TIME</th>
                    <th className="text-right">REWARD</th>
                  </tr>
                </thead>
                <tbody>
                  {leaderboard.slice(0, 20).map((item, i) => (
                    <tr key={i} style={{background: item.address.toLowerCase() === this.props.address?.toLowerCase() ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(33, 36, 64, 0.15) 100%)' : '' }}>
                      <td> {i + 1} </td>
                      {/* <td> {item.address} </td> */}
                      <td> {item.username} </td>
                      <td className="text-right"> {item.score} </td>
                      <td className="text-right"> {item.level} </td>
                      <td className="text-right">
                        {" "}
                        {formatTimeByLevelAndSecond(
                          item.timestamp,
                          item.level
                        )}{" "}
                      </td>
                      <td className="text-right">${caws2dRewards[i]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  }
}
